import { ControlledDropDown, FormInput } from '@ui-kit'
import { DATA_CHECK } from '../../../utils/constants'
import { DataType, DropdownType } from '@app-store'
import { UseFormReturn } from 'react-hook-form'
import { RootState, useAppSelector } from '../../../utils/agent.store'
import { AddDataCorrectionsFormType } from '../../../types/dataCorrection.types'

export const AddDataFields = ({
  methods,
}: {
  methods: UseFormReturn<AddDataCorrectionsFormType>
  selectedRow: DataType | null
}) => {
  const errorTypeOptions = useAppSelector(
    (state: RootState) => state?.categoryDropdown?.categoryMap?.error_type
  )?.map((item: DataType) => ({
    value: item?.value,
    label: item?.label,
    id: item?.id,
  }))

  const {
    register,
    formState: { errors },
    control,
    setValue,
  } = methods

  return (
    <div className="gap-[0.40625rem] justify-between w-full grid grid-cols-3">
      <FormInput
        label={DATA_CHECK.FIELD_NAME}
        placeholder="--"
        errors={errors}
        name={'field_name'}
        register={register}
        validation={{ required: true }}
        disabled={false}
        dataQaId={DATA_CHECK.ISSUE_DESCRIPTION}
      />
      <ControlledDropDown
        name={'error_type_label'}
        label={DATA_CHECK.ERROR_TYPE}
        onChange={(e) => {
          setValue('error_type_label', e?.label)
          setValue('error_type', e?.id as string)
        }}
        isCrossable={false}
        options={errorTypeOptions as DropdownType<string | number, string>[]}
        errors={errors}
        control={control}
        dataQaId={DATA_CHECK.ERROR_TYPE}
        required={true}
      />
      <FormInput
        label={DATA_CHECK.ISSUE_DESCRIPTION}
        placeholder="--"
        errors={errors}
        name={'description'}
        register={register}
        validation={{ required: false }}
        disabled={false}
        dataQaId={DATA_CHECK.ISSUE_DESCRIPTION}
      />
    </div>
  )
}
